var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSidebarMidscreenOptimizedindex = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "127px",
    viewBox: "0 0 128 127",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OB---Side-Menu-2",
    transform: "translate(-10.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OB---Side-Menu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "optimizer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "optimizer",
    transform: "translate(20.000000, 45.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 1.16766467
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.065639,47.2825374 L111.504398,47.2825374 C110.753347,45.0310701 109.840094,42.8362528 108.771108,40.7143416 L116.227638,33.3318638 C116.228136,33.3313712 116.228634,33.3308786 116.229131,33.3303859 C118.301177,31.2779325 118.30068,27.9511008 116.227638,25.8993862 L101.213575,11.0344311 C99.113666,9.04995766 95.8091889,9.04995766 93.7092798,11.0344311 L86.2420521,18.4223276 C84.099105,17.3642045 81.882023,16.4597752 79.6079716,15.7161826 L79.6079716,5.25440892 C79.6079716,2.35245205 77.2319224,0 74.3008564,0 L53.0721469,0 C50.1408321,0 47.7647829,2.35245205 47.7647829,5.25440892 L47.7647829,15.7161826 C45.4882437,16.4575585 43.2684252,17.3602636 41.1227416,18.4169089 L33.6662112,11.0344311 C31.5663021,9.04700201 28.2590885,9.04700201 26.1591795,11.0344311 L11.145116,25.8993862 C9.07331856,27.9513471 9.07331856,31.2774399 11.145116,33.3291544 L18.6071195,40.7222233 C17.5383825,42.8438882 16.624881,45.0389519 15.8738295,47.2904192 L5.30711518,47.2904192 C2.37604918,47.2904192 0,49.6428712 0,52.5448281 L0,63.0538922 L5.30711518,63.0538922 L5.30711518,52.5448281 L17.8294491,52.5448281 C19.012125,52.5450744 20.0520042,51.7704475 20.3796407,50.6453296 C21.3001079,47.4618469 22.5763232,44.3899401 24.1849018,41.4867517 C24.7573328,40.4618797 24.5754784,39.1857773 23.7390971,38.3577023 L14.8998758,29.6141472 L29.9112027,14.7519014 L38.7529118,23.5033383 C39.5887955,24.3301817 40.8762056,24.5099839 41.9106117,23.9447156 C44.8406826,22.3530974 47.9406668,21.0895565 51.1530972,20.1772455 C52.289501,19.8528628 53.0718981,18.823311 53.0716493,17.6523805 L53.0716493,5.25440892 L74.3003588,5.25440892 L74.3003588,17.6523805 C74.3001101,18.823311 75.0825071,19.8528628 76.2189109,20.1772455 C79.435073,21.0888176 82.53854,22.3523585 85.4720938,23.9447156 C86.5064998,24.5099839 87.79391,24.3301817 88.6297937,23.5033383 L97.4610543,14.7519014 L112.472381,29.6141472 L103.63316,38.3655841 C102.796779,39.193659 102.614924,40.4697614 103.187355,41.4946335 C104.795436,44.3953588 106.071652,47.4645563 106.992616,50.6453296 C107.320253,51.7704475 108.360132,52.5450744 109.542808,52.5448281 L122.065142,52.5448281 L122.065142,63.0538922 L127.372754,63.0538922 L127.372754,52.5369463 C127.372754,49.6349895 124.996705,47.2825374 122.065639,47.2825374 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3005222,34.251497 C48.8050459,34.251497 37.0538922,45.9744325 37.0538922,60.4356489 L37.0538922,63.0538922 L42.3031198,63.0538922 L42.3031198,60.4354034 C42.3033659,48.8666266 51.7041412,39.4882292 63.3005222,39.4882292 C74.8969033,39.4882292 84.2976786,48.8666266 84.2976786,60.4354034 L84.2976786,63.0538922 L89.5469062,63.0538922 L89.5469062,60.4354034 C89.5469062,45.9744325 77.7959986,34.251497 63.3005222,34.251497 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 62.5284431,
    y: 13.2335329,
    width: 4.63173653,
    height: 4.67065868
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 29.3343313,
    y: 27.245509,
    width: 4.63173653,
    height: 4.67065868
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 14.6671657,
    y: 59.9401198,
    width: 4.63173653,
    height: 4.67065868
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 97.2664671,
    y: 27.245509,
    width: 4.63173653,
    height: 4.67065868
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.253146,80.1796407 L18.1196086,80.1796407 C16.6392722,80.1796407 15.4391218,81.3414671 15.4391218,82.7745322 L15.4391218,95.748503 L20.7998442,95.748503 L20.7998442,85.3691804 L106.572659,85.3691804 L106.572659,95.748503 L111.933633,95.748503 L111.933633,82.7745322 C111.933633,81.3414671 110.733482,80.1796407 109.253146,80.1796407 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 61.756487,
    y: 63.0538922,
    width: 4.63173653,
    height: 33.4730539
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6863772,48.2634731 C56.2254353,48.2634731 50.1771457,54.0721183 50.1771457,61.2374439 L50.1771457,63.8323353 L55.5807877,63.8323353 L55.5807877,61.2374439 C55.5807877,56.9382485 59.2098121,53.4530127 63.6863772,53.4530127 C68.1629424,53.4530127 71.7919668,56.9382485 71.7919668,61.2374439 L71.7919668,63.8323353 L77.1956088,63.8323353 L77.1956088,61.2374439 C77.1956088,54.0721183 71.1473192,48.2634731 63.6863772,48.2634731 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("text", {
    id: "OPTIMIZED-INDEX",
    fontFamily: "NHaasGroteskTXPro-Bd, Neue Haas Grotesk Text Pro",
    fontSize: 12.5,
    fontWeight: "bold",
    letterSpacing: -0.181818,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 12
  }, "OPTIMIZED INDEX"))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSidebarMidscreenOptimizedindex, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sidebar-midscreen-optimizedindex.fd0a4855.svg";
export { ForwardRef as ReactComponent };